import cookie from 'cookie'
import type { NextPageContext } from 'next'

export function parseReqCookies(req: NextPageContext['req']) {
  return cookie.parse(req ? req.headers.cookie || '' : document.cookie)
}
